import React from "react";
 
import PrimarySchoolTable from "./PrimarySchoolTable";

function PrimarySchool() {
  return (
    <>
    
       
        <PrimarySchoolTable />
      
       
    </>
  );
}

export default PrimarySchool;
